module.exports = __webpack_public_path__ + "img/zch.41a5816d.png";